export interface MapSize {
  entries: number;
  bytes: number;
  kb: number;
  tokenEstimate: number;
}

/**
 * Calculates the size of a Map's values when serialized to JSON.
 * @param map - The Map whose values to measure.
 * @returns An object containing entries count, bytes, kilobytes, and token estimate.
 */
export function getMapSize<T>(map: Map<any, T>): MapSize {
  const entries = map.size;
  const docsArray = Array.from(map.values());
  const json = JSON.stringify(docsArray);
  const bytes = new TextEncoder().encode(json).length;
  const kb = Number((bytes / 1024).toFixed(2));
  const tokenEstimate = Math.ceil(bytes / 4);
  return { entries, bytes, kb, tokenEstimate };
}
